<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ResultMessage')"
      width="470px"
      :close-on-click-modal="false"
      destroy-on-close
      class="app-main-inner booking-fail"
    >
      <div style="height: 160px;display: flex;align-items: center; justify-content: center;padding: 50px" class="booking-fail-body">
        <div
          v-if="selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH.code
            || selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY.code
            || selectData.bookingErrorCode === BOOKING_ERROR_CODE_MBL_NOT_FOUND.code
            || selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL.code"
        >
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span>
          <span style="color: #f7b45c">{{ selectData.bookingErrorMsg }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span><br>
          <span style="color: #f7b45c">{{ $t('CargoMsg.Cargo_UserName_Password_Maintained') }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span><br>
          <span style="color: #f7b45c">{{ $t('CargoMsg.Cargo_ShipCompany_Maintained') }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span><br>
          <span style="color: #f7b45c">{{ $t('CargoMsg.Cargo_ShippingCompanyCode_MaintainedTip') }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS.code || selectData.bookingErrorCode === BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span><br>
          <span style="color: #f7b45c">{{ selectData.bookingErrorMsg }}</span>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED.code">
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span><br>
          <span style="color: #f7b45c">{{ $t('CargoMsg.Cargo_BookingChannelConfig_MaintainedTip') }}</span>
        </div>
        <div v-else>
          <span>{{ ColumnUtils.bookingErrorCodeLabelFunc(selectData) }}</span>
        </div>
      </div>
      <div slot="footer">
        <div
          v-if="selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH.code
            || selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY.code"
        >
          <el-button size="mini" @click="innerVisible = false">{{ $t('SeaExport.Confirm') }}</el-button>
          <el-button type="primary" size="mini" @click="queryTemplates">{{ $t('Message.SelectTemplate') }}</el-button>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.code">
          <el-button type="primary" size="mini" @click="noBooking">{{ $t('CargoMsg.Cargo_NotBooking') }}</el-button>
          <el-button type="primary" size="mini" @click="booking">{{ $t('CargoMsg.Cargo_ContinueBooking') }}</el-button>
        </div>
        <div v-else-if="selectData.bookingErrorCode === BOOKING_ERROR_CODE_MBL_NOT_FOUND.code || selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL.code || selectData.bookingErrorCode === BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS.code">
          <el-button type="primary" size="mini" @click="changeInfoHandle">{{ $t('CargoMsg.Cargo_ChangeInfo') }}</el-button>
        </div>
        <div v-else>
          <el-button type="primary" size="mini" @click="innerVisible = false">{{ $t('CargoMsg.Cargo_Got_It') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- edi模板选择弹窗-->
    <dialog-selector
      :visible.sync="ediSelectorDialog.visible"
      :title="$t('SeaExport.BookingEDI')"
      :row-data="ediSelectorDialog.rowData"
      @selected="p => booking(p.uuid)"
    />
  </div>
</template>

<script>
import {
  getMatchedOrAllBookingTemplates,
  importEDITextFromTemplateUuid,
  noBooking
} from '@/api/seaExport/edi'
import {
  BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH,
  BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD,
  BOOKING_ERROR_CODE_MBL_NOT_FOUND,
  BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL,
  BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY,
  EDI_EDIT_STATUS_NEW, JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS, JOB_BOOKING_STATE_BOOKING,
  BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED,
  BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED,
  BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED,
  BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS,
  BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL,
  BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED
} from '@/class/cargo/model/parameters/SystemConstants'
import { BOOKING_EDI_TYPE } from '@/class/cargo/model/parameters/EdiType'
import ColumnUtils from '@/utils/ColumnUtils'
import DialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BookingFailDialog',
  components: {
    DialogSelector
  },
  props: {
    visible: { type: Boolean, required: true },
    selectData: { type: Object, required: true }
  },
  data() {
    return {
      ColumnUtils,
      BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH,
      BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY,
      BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD,
      BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL,
      BOOKING_ERROR_CODE_MBL_NOT_FOUND,
      BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED,
      BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED,
      BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED,
      BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS,
      BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL,
      BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED,
      BOOKING_EDI_TYPE,
      innerVisible: false,
      ediSelectorDialog: {
        visible: false,
        rowData: []
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async queryTemplates() {
      await getMatchedOrAllBookingTemplates({
        opOffice: this.selectData.opOffice, carrierId: this.selectData.carrierId,
        bookingAgent: this.selectData.bookingAgent, carrierAgentId: this.selectData.carrierAgentId
      }).then(res => {
        this.ediSelectorDialog.rowData = res.data
        this.ediSelectorDialog.visible = true
      })
    },
    booking(templateUuid) {
      const params = {
        'templateUuid': templateUuid,
        'bookingErrorCode': this.selectData.bookingErrorCode,
        'jobUuid': this.selectData.uuid,
        'ediType': BOOKING_EDI_TYPE.code,
        'editStatus': EDI_EDIT_STATUS_NEW, // 原始
        'sendVersion': 1,
        'bookingSendMethod': SystemConstants.BOOKING_SEND_METHOD_MANUAL.code // 订舱发送方式：手动
      }
      const loading = getLoading()
      importEDITextFromTemplateUuid(params).then(async res => {
        if (JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code === res.data.bookingState) {
          this.$message.success(this.$t('SeaExport.BookingSuccess'))
          this.innerVisible = false
          this.$emit('refresh')
          return
        }
        if (JOB_BOOKING_STATE_BOOKING.code === res.data.bookingState) {
          this.$message.success(this.$t('CargoMsg.Cargo_BookingInProgress'))
          this.innerVisible = false
          this.$emit('refresh')
          return
        }
        this.selectData.bookingState = res.data.bookingState
        this.selectData.bookingErrorCode = res.data.bookingErrorCode
        this.selectData.bookingErrorMsg = res.data.bookingErrorMsg
        if (this.selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH.code ||
          this.selectData.bookingErrorCode === BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY.code) {
          await this.queryTemplates()
        }
        this.$emit('refresh')
      }).finally(() => {
        loading.close()
      })
    },
    noBooking() {
      const loading = getLoading()
      noBooking({ 'jobUuid': this.selectData.uuid }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.innerVisible = false
        this.$emit('refresh')
      }).finally(() => {
        loading.close()
      })
    },
    changeInfoHandle() {
      this.innerVisible = false
      this.$router.push({ name: 'SeaBooking', query: { jobNo: this.selectData.jobNo, activeTabName: 'tabVesselEq' }})
    }
  }
}
</script>

<style lang="scss">
.booking-fail {
  .el-dialog__body {
    padding: 0 !important;
  }
  .booking-fail-body {
    span {
      font-size: 18px;
    }
  }
}
</style>
